import { cn } from '@dfh-corp-sites/ui/utils'
import React, { FC } from 'react'

import {
  ConfigurableProductDetailsFragment,
  SimpleProductDetailsFragment,
} from '../../../../graphql/magento'
import { displayAttribute } from '../../../../utils/itemTools'

export interface ItemAdvisorTagsProps {
  className?: string
  item: ConfigurableProductDetailsFragment
  selectedVariant: SimpleProductDetailsFragment | null | undefined
}

const ItemAdvisorTags: FC<ItemAdvisorTagsProps> = ({
  className = '',
  item,
  selectedVariant = null,
}) => {
  const advisorTags = displayAttribute({
    item,
    selectedVariant,
    attribute: 'advisor_tags',
  })

  if (advisorTags?.length) {
    return (
      <div className={cn('text-xs font-bold tracking-wider leading-[14px] uppercase', className)}>
        {advisorTags.map((advisorTag) => (
          <span
            className="mr-2.5 before:mr-[3px] before:content-['•'] last-of-type:mr-0"
            key={advisorTag}
          >
            {advisorTag}
          </span>
        ))}
      </div>
    )
  }

  return null
}

export default ItemAdvisorTags
